import setFolderNodeViewState from '../actions/setFolderNodeViewState';
import { getStore } from '../store/Store';
import { mutator } from 'satcheljs';

/**
 * Mutator that sets folderNodeViewState in the store.
 */
export default mutator(setFolderNodeViewState, actionMessage => {
    const { folderId, viewState } = actionMessage;
    getStore().folderNodeViewStates.set(folderId, viewState);
});
